var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.8967L27.1725 38.0692C26.5885 37.4852 25.6415 37.4852 25.0575 38.0692C24.4735 38.6533 24.4735 39.6002 25.0575 40.1842L30 45.1267L40.9425 34.1842C41.5265 33.6002 41.5265 32.6533 40.9425 32.0692C40.3585 31.4852 39.4115 31.4852 38.8275 32.0692L30 40.8967Z",
    fill: "#ABE138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42.125V15.125H33V27.125C33 27.9534 33.6716 28.625 34.5 28.625C35.3284 28.625 36 27.9534 36 27.125V9.125C35.9992 8.32959 35.6829 7.56699 35.1204 7.00456C34.558 6.44212 33.7954 6.12579 33 6.125H15C14.2046 6.12579 13.442 6.44212 12.8796 7.00456C12.3171 7.56699 12.0008 8.32959 12 9.125V42.125C12.0008 42.9204 12.3171 43.683 12.8796 44.2454C13.442 44.8079 14.2046 45.1242 15 45.125H19.5C20.3284 45.125 21 44.4534 21 43.625C21 42.7966 20.3284 42.125 19.5 42.125H15ZM15 9.125H33V12.125H15V9.125Z",
    fill: "#ABE138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCheck);
export default __webpack_public_path__ + "static/media/phone-check.c3adcc2defd121518440fe53f831777a.svg";
export { ForwardRef as ReactComponent };